import { Link } from 'react-router';
import { Card, CardBody, CardTitle, Wordmark } from '../../ui';
import { useInstance } from '../instance/InstanceProvider';
import { poweredBy } from '../platform';
import { useSession } from '../session/SessionProvider';
import { text } from '../../shared/text';

/**
 * What a client sees at `/c/<slug>/`.
 *
 * Before sign-in this is the instance's own front door: its name, its coach,
 * and nothing else. The six branding columns behind it are the only thing an
 * unauthenticated visitor may ever learn about an instance (design.md F4).
 *
 * There is no sign-in form here on purpose. A client signs in from the link in
 * their invitation, and there is no client sign-up (D19) — so a form would only
 * ever be a way to find out whether an address is a client of this coach.
 */
export function ClientHome() {
  const instance = useInstance();
  const { status, profile } = useSession();
  const platform = poweredBy();

  const signedIn = status === 'authenticated' && profile?.role === 'client';

  return (
    <main className="mx-auto flex min-h-dvh w-full max-w-md flex-col justify-center px-4 py-10">
      <div className="mb-6 text-center">
        <Wordmark
          name={instance.displayName}
          text={instance.wordmarkText}
          logoUrl={instance.logoUrl}
          size="lg"
        />
      </div>

      <Card>
        <CardTitle>{instance.displayName}</CardTitle>
        <CardBody>
          {text('client.home.coachLine', {
            coach: instance.coachDisplayName,
            role: instance.roleLine,
          })}
        </CardBody>
        <CardBody>{signedIn ? text('client.home.signedIn') : text('client.home.signIn')}</CardBody>

        {signedIn ? (
          <p className="mt-4">
            <Link
              to="today"
              className="text-primary text-sm font-medium underline-offset-2 hover:underline"
            >
              {text('client.home.goToWeek')}
            </Link>
          </p>
        ) : null}
      </Card>

      <footer className="text-ink-muted mt-6 text-center text-xs">
        {platform === null ? null : <p>{platform}</p>}
      </footer>
    </main>
  );
}
